var initialScrollOnNavReveal, header, navbar, revealer;
var isSearchActive = false;
var isSocialActive = false;

document.addEventListener('DOMContentLoaded', function() {
    revealer = document.getElementById("navbar-revealer");
    header = document.getElementById("top-header");
    navbar = document.getElementById("top-navbar");

    // Set whitespace:
    document.getElementById("header-whitespace").style.paddingTop = navbar.offsetHeight + "px";
    window.onresize = function() {
        document.getElementById("header-whitespace").style.paddingTop = navbar.offsetHeight + "px";
    };

    // Add event listeners
    window.addEventListener("scroll", scrollShowRevealer, false);
    revealer.addEventListener('click', revealTopbar);
    for (let btn of document.querySelectorAll(".top-searchbtn")) {
        btn.addEventListener('click', slideDownSearch);
    }
    for (let btn of document.querySelectorAll(".top-social")) {
        btn.addEventListener('click', slideDownSocial);
    }

    /****************************
     * TOP BAR REVEAL FUNCTIONS *
     ****************************/

    /**
     * Show topbar.
     *
     * Shows topbar and hides revealer for the time being.
     * Listens to scroll to hide the topbar after 100px again.
     */
    function revealTopbar() {
        _showTopbar();

        initialScrollOnNavReveal = window.pageYOffset;
        window.addEventListener("scroll", hideTopbarAfterScrolling, false);

        _hideRevealer();
        window.removeEventListener("scroll", scrollShowRevealer, false);
        window.removeEventListener("scroll", scrollHideRevealer, false);
    }

    function hideTopbarAfterScrolling() {
        let scrolledPixels = window.pageYOffset - initialScrollOnNavReveal;

        if (scrolledPixels > 100) {
            _hideTopbar();
            navbar.addEventListener("animationend", hideTopbarAfterAnimation);
        } else if (initialScrollOnNavReveal == 0) {
            _reattachTopbar();
        } else if (scrolledPixels < 0) { // User scrolled up
            initialScrollOnNavReveal = window.pageYOffset;
        }
    }

    /**
     * Reset the navbar to its former position in the DOM.
     */
    function hideTopbarAfterAnimation() {
        _reattachTopbar();
        _showRevealer();

        window.addEventListener("scroll", scrollHideRevealer, false);
        window.removeEventListener("scroll", hideTopbarAfterScrolling, false);
        navbar.removeEventListener("animationend", hideTopbarAfterAnimation);
    }

    function scrollShowRevealer(revealer) {
        if (window.pageYOffset > header.offsetHeight) {
            _showRevealer();
            window.removeEventListener("scroll", scrollShowRevealer, false);
            window.addEventListener("scroll", scrollHideRevealer, false);
        }
    }

    /**
     * Hide the revealer if we've almost reached the top.
     */
    function scrollHideRevealer(revealer) {
        if (window.pageYOffset < header.offsetHeight) {
            if (window.pageYOffset < 1) {
                _deactivateRevealer();
            } else {
                _hideRevealer();
                window.addEventListener("scroll", forceHideRevealer, false);
            }

            window.removeEventListener("scroll", scrollHideRevealer, false);
            window.addEventListener("scroll", scrollShowRevealer, false);
        }
    }

    /**
     * "Hard-shutdown" the revealer.
     *
     * On browsers with elastic scrolling (i.e. Safari), the revealer could be
     * visible over the header if scroll position is > 0.
     * If the scroll position reaches near 0, abort running animations
     * and just hide the element.
     */
    function forceHideRevealer(revealer) {
        if (window.pageYOffset < 1) {
            _deactivateRevealer();
            window.removeEventListener("scroll", forceHideRevealer, false);
        }
    }

    function _showRevealer() {
        revealer.classList.remove("closed");
        revealer.classList.add("opened");
    }

    function _hideRevealer() {
        revealer.classList.remove("opened");
        revealer.classList.add("closed");
    }

    function _deactivateRevealer() {
        revealer.classList.remove("opened");
        revealer.classList.remove("closed");
    }

    function _showTopbar() {
        navbar.style.position = "fixed";
        navbar.classList.remove("closed");
        navbar.classList.add("opened");
    }

    function _hideTopbar() {
        navbar.classList.remove("opened");
        navbar.classList.add("closed");
    }

    function _reattachTopbar() {
        navbar.style.position = "";
        navbar.classList.remove("closed");
    }

    /******************************
     * BUTTON SLIDEDOWN FUNCTIONS *
     ******************************/

    function slideDownSearch() {
        if (isSearchActive === false) {
            _activateSearch();
            if (isSocialActive === true) {
                _deactivateSocial();
            }
        } else {
            _deactivateSearch();
        }
    }

    function slideDownSocial() {
        if (isSocialActive === false) {
            _activateSocial();
            if (isSearchActive === true) {
                _deactivateSearch();
            }
        } else {
            _deactivateSocial();
        }
    }

    function _activateSearch() {
        isSearchActive = true;
        document.querySelector("#top-slidedown input").style.display = "inline-block";

        animateSliding(document.querySelector("#top-slidedown form"));
    }

    function _deactivateSearch() {
        isSearchActive = false;
        animateSliding(
            document.querySelector("#top-slidedown form"), true, function() {
                document.querySelector("#top-slidedown input").style.display = "";
            }
        );
    }

    function _activateSocial() {
        isSocialActive = true;
        document.querySelector("#slidedown-social").style.display = "block";

        animateSliding(document.querySelector("#slidedown-social"));
    }

    function _deactivateSocial() {
        isSocialActive = false;
        animateSliding(
            document.querySelector("#slidedown-social"), true, function() {
                document.querySelector("#slidedown-social").style.display = "";
            }
        );
    }

    function animateSliding(toAnimate, reverse = false, callback = function(){}) {
        var elapsed, start;

        const animate = ( time => {
            elapsed = time - start;
            if (elapsed < 500) {
                let x = (reverse ? (1 - _ease(elapsed / 500)) : _ease(elapsed/500));
                toAnimate.style.height = Math.round(x * 42) + "px";
                window.requestAnimationFrame(animate);
            } else {
                callback();
            }
        } );

        window.requestAnimationFrame(function(time) {
            start = time;
            animate(time);
        });
    }

    /**
     * JS easing function courtesy of gre@github (easing.js, "EaseInOutQuad")
     */
    function _ease(x) {
        return x < 0.5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
    }
}, false);
